export default __webpack_public_path__ + "static/media/Doctor_03.b97a646c.jpg";